module.exports = "<i alt=\"{{'uxf.uxf.Grid_View_Action' | translate}}\" ng-if=isRowSelected(rowNode) ng-class=\"{&quot;gz-clickable&quot;: !gotoDisabled(), disabled: gotoDisabled()}\" ng-click=\"drillDownClicked(rowNode, $event)\" class=\"fa fa-caret-right fa-2x gz-action-btn\"><md-tooltip ng-if=drillDownTooltip>{{drillDownTooltip}}</md-tooltip><md-tooltip ng-if=!drillDownTooltip>{{'uxf.uxf.Grid_View_Action' | translate}}</md-tooltip></i>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/extensions/grid/grid-action-cell.jade
// module id = 258
// module chunks = 0